module.exports = __webpack_public_path__ + "static/media/IconTemplates_-86.a5d5be39.svg";